var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import { InternalProvider } from '../../util/InternalProvider';
import { SelectionChipElement, TextElement } from './elements';
import { ChipIcon } from './ChipIcon';
export var SelectionChip = React.forwardRef(function (_a, fRef) {
    var id = _a.id, _b = _a.className, className = _b === void 0 ? '' : _b, label = _a.label, _c = _a.size, size = _c === void 0 ? 'small' : _c, iconLeftSrc = _a.iconLeftSrc, iconRightSrc = _a.iconRightSrc, _d = _a.hideDefaultIcon, hideDefaultIcon = _d === void 0 ? false : _d, _e = _a.variant, variant = _e === void 0 ? 'normal' : _e, _f = _a.type, type = _f === void 0 ? 'selection' : _f, _g = _a.isSelected, isSelected = _g === void 0 ? false : _g, edgeItemsMargin = _a.edgeItemsMargin, rest = __rest(_a, ["id", "className", "label", "size", "iconLeftSrc", "iconRightSrc", "hideDefaultIcon", "variant", "type", "isSelected", "edgeItemsMargin"]);
    var renderIcon = function (side) {
        var isFilter = type === 'filter';
        var src;
        if (side === 'left') {
            if (!isFilter && isSelected && !hideDefaultIcon) {
                src = 'CheckmarkV';
            }
            else if (isFilter && iconLeftSrc) {
                src = iconLeftSrc;
            }
        }
        else {
            if (isFilter && isSelected && !hideDefaultIcon) {
                src = 'CloseX';
            }
            else if (!isFilter && iconRightSrc) {
                src = iconRightSrc;
            }
        }
        return src && React.createElement(ChipIcon, { src: src, size: size, side: side });
    };
    var leftIcon = useMemo(function () { return renderIcon('left'); }, [iconLeftSrc, type, isSelected]);
    var rightIcon = useMemo(function () { return renderIcon('right'); }, [iconRightSrc, type, isSelected]);
    return (React.createElement(InternalProvider, null,
        React.createElement(SelectionChipElement, __assign({ ref: fRef, id: id, className: "chipElement ".concat(className), role: "checkbox", "aria-checked": isSelected, tabIndex: 0, "$selected": isSelected, "$size": size, "$variant": variant, "$edgeItemsMargin": edgeItemsMargin }, rest),
            leftIcon,
            React.createElement(TextElement, { className: "textElement" }, label),
            rightIcon)));
});
